import * as ReactDOM from "react-dom";

const DEFAULT_BACKGROUND_COLOR = "#fff";

export const getBackgroundColor = (ref: any): string => {
    const el = ReactDOM.findDOMNode(ref);
    if (el && el.parentElement) {
      if (el.nodeName === "BODY") {
        return DEFAULT_BACKGROUND_COLOR;
      }
      const bgColor = window.getComputedStyle(el.parentElement, null)
        .backgroundColor;
  
      if (bgColor && bgColor !== "rgba(0, 0, 0, 0)") {
        return bgColor;
      }
  
      return getBackgroundColor(el.parentElement);
    }
    return DEFAULT_BACKGROUND_COLOR;
  };